import React from "react";

interface IProps {
 label: string
}

const AppLoader = ({label}: IProps) => <div className="AppLoader"><label>{label}</label></div>

export default AppLoader
